import { useFetchMixAPi1, useMixApi1Toast } from "hooks";
import { useMxfNestToast } from "hooks/useMxfApiNest";
import { getURLWithParams } from "utils/context";

export const useProductsDirectClassList = (params = {}) => {
  const hasParams = Object.keys(params).length > 0;
  const url = hasParams
    ? getURLWithParams("/legislacao/produtos/class-direta", params)
    : null;

  const result = useFetchMixAPi1(url);

  if (!hasParams) {
    return {
      data: [],
      isLoading: false,
    };
  }

  return result;
};

export const useInsertProductsDirectClass = () => {
  const { onSend } = useMixApi1Toast();

  const onInsert = data =>
    onSend({
      endpoint: "/legislacao/tributacao-direta-produto/bulk-create",
      data,
      messageSuccess: "Produtos classificados com sucesso!",
      messageFail: "Erro ao classificar produtos!",
      type: "POST",
    });

  const onDestroy = data =>
    onSend({
      endpoint: "/legislacao/tributacao-direta-produto/destroy",
      data,
      messageSuccess: "Produtos desclassificados com sucesso!",
      messageFail: "Erro ao desclassificar produtos!",
      type: "DELETE",
    });

  return {
    onInsert,
    onDestroy,
  };
};

export const useNewProductsDirectClass = () => {
  const { onSend } = useMxfNestToast();

  const onInsert = data =>
    onSend({
      endpoint: "/tributacao-direta",
      data,
      messageSuccess: "Produtos classificados com sucesso!",
      messageFail: "Erro ao classificar produtos!",
      type: "POST",
    });

  const onDestroy = data =>
    onSend({
      endpoint: "/tributacao-direta/bulk",
      data,
      messageSuccess: "Produtos desclassificados com sucesso!",
      messageFail: "Erro ao desclassificar produtos!",
      type: "DELETE",
    });

  return {
    onInsert,
    onDestroy,
  };
};
